export default __webpack_public_path__ + "assets/silver-8ff6f4bd5e0dc2c4231c54a160a7e6e7.svg";